import AccountSwitcherHeader from './AccountSwitcherHeader';

export default AccountSwitcherHeader;
